__turbopack_context__.v({
  "actionsWrapper": "index-module__tQIj_q__actionsWrapper",
  "container": "index-module__tQIj_q__container",
  "ghIconWrapper": "index-module__tQIj_q__ghIconWrapper",
  "main": "index-module__tQIj_q__main",
  "navInteractionIcon": "index-module__tQIj_q__navInteractionIcon",
  "navItems": "index-module__tQIj_q__navItems",
  "nodeIconAndMobileItemsToggler": "index-module__tQIj_q__nodeIconAndMobileItemsToggler",
  "nodeIconWrapper": "index-module__tQIj_q__nodeIconWrapper",
  "searchButtonSkeleton": "index-module__tQIj_q__searchButtonSkeleton",
  "sidebarItemToggler": "index-module__tQIj_q__sidebarItemToggler",
  "sidebarItemTogglerLabel": "index-module__tQIj_q__sidebarItemTogglerLabel",
});
